// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file responses/v1/shopify_plans_response.proto (package responses.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import type { ShopifyPlan } from '../../subscription/v1/shopify_plan_pb';
import { file_subscription_v1_shopify_plan } from '../../subscription/v1/shopify_plan_pb';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file responses/v1/shopify_plans_response.proto.
 */
export const file_responses_v1_shopify_plans_response: GenFile =
    /*@__PURE__*/
    fileDesc(
        'CilyZXNwb25zZXMvdjEvc2hvcGlmeV9wbGFuc19yZXNwb25zZS5wcm90bxIMcmVzcG9uc2VzLnYxIkMKFFNob3BpZnlQbGFuc1Jlc3BvbnNlEisKBXBsYW5zGAEgAygLMhwuc3Vic2NyaXB0aW9uLnYxLlNob3BpZnlQbGFuQoQBChBjb20ucmVzcG9uc2VzLnYxQhlTaG9waWZ5UGxhbnNSZXNwb25zZVByb3RvUAFaBC4vcGKiAgNSWFiqAgxSZXNwb25zZXMuVjHKAgxSZXNwb25zZXNcVjHiAhhSZXNwb25zZXNcVjFcR1BCTWV0YWRhdGHqAg1SZXNwb25zZXM6OlYxYgZwcm90bzM',
        [file_subscription_v1_shopify_plan]
    );

/**
 * @generated from message responses.v1.ShopifyPlansResponse
 */
export type ShopifyPlansResponse = Message<'responses.v1.ShopifyPlansResponse'> & {
    /**
     * @generated from field: repeated subscription.v1.ShopifyPlan plans = 1;
     */
    plans: ShopifyPlan[];
};

/**
 * Describes the message responses.v1.ShopifyPlansResponse.
 * Use `create(ShopifyPlansResponseSchema)` to create a new message.
 */
export const ShopifyPlansResponseSchema: GenMessage<ShopifyPlansResponse> =
    /*@__PURE__*/
    messageDesc(file_responses_v1_shopify_plans_response, 0);
